/**
 * FormTabs — navegacao entre as 5 visões de um formulario:
 *   Editor (/:id) · Design (/:id/design) · Respostas (/:id/respostas) ·
 *   Dashboard (/:id/dashboard) · Publicar (/:id/publicar).
 *
 * Renderizada abaixo do EntityHeader em todas as telas. A aba ativa eh
 * informada por quem renderiza.
 *
 * `onNavegar(destino)` (opcional): quem tem alteracao nao salva recebe o
 * caminho e decide se segue (Editor, FORM-31). Sem ele, a aba navega direto.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiBarChart2, FiEdit3, FiGlobe, FiLayout, FiList } from "react-icons/fi";

import { FormTab, FormTabsBar } from "./styles";

const ABAS = [
  { key: "editor", label: "Editor", icon: FiEdit3, sufixo: "" },
  { key: "design", label: "Design", icon: FiLayout, sufixo: "/design" },
  { key: "respostas", label: "Respostas", icon: FiList, sufixo: "/respostas" },
  { key: "dashboard", label: "Dashboard", icon: FiBarChart2, sufixo: "/dashboard" },
  { key: "publicar", label: "Publicar no meu site", icon: FiGlobe, sufixo: "/publicar" },
];

export default function FormTabs({ id, ativa, onNavegar }) {
  const navigate = useNavigate();
  if (!id) return null;

  return (
    <FormTabsBar aria-label="Visoes do formulario">
      {ABAS.map((aba) => {
        const Icone = aba.icon;
        const active = aba.key === ativa;
        return (
          <FormTab
            key={aba.key}
            type="button"
            $active={active}
            aria-current={active ? "page" : undefined}
            onClick={() => {
              if (active) return;
              const destino = `/comercial/formularios/${id}${aba.sufixo}`;
              if (onNavegar) onNavegar(destino);
              else navigate(destino);
            }}
          >
            <Icone aria-hidden="true" />
            {aba.label}
          </FormTab>
        );
      })}
    </FormTabsBar>
  );
}
